<script setup>
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';

defineProps({
  text: {
    type: String,
    default: '',
  },
  margin: {
    type: String,
    default: 'mb-14',
  },
});
</script>

<template>
  <BasicBlock
    :icon="['fal', 'coins']"
    :text="text"
    :ariaDescription="$t('activity.price')"
  />
</template>
